/**
 * Red "BETA" chip shown next to the Lumnian wordmark.
 *
 * Two jobs: set the expectation that things move and occasionally break, and
 * give people a one-click path to say so when they do.
 *
 * Set REACT_APP_BUG_REPORT_URL at build time (a mailto:, a GitHub issues URL, a
 * form — anything an anchor can open) and the chip becomes that link. With it
 * unset the chip stays informational, so an unconfigured build still renders
 * correctly rather than shipping a dead link.
 */

const BUG_REPORT_URL = process.env.REACT_APP_BUG_REPORT_URL || '';

interface BetaBadgeProps {
  className?: string;
}

const CHIP =
  'inline-flex items-center rounded-full bg-red-600 px-1.5 py-0.5 text-[10px] ' +
  'font-bold uppercase leading-none tracking-wider text-white dark:bg-red-500';

export default function BetaBadge({ className = '' }: BetaBadgeProps) {
  const classes = `${CHIP} ${className}`.trim();

  if (!BUG_REPORT_URL) {
    return (
      <span className={classes} title="Beta - expect rough edges while we build.">
        Beta
      </span>
    );
  }

  return (
    <a
      href={BUG_REPORT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${classes} transition-colors hover:bg-red-700 dark:hover:bg-red-400`}
      title="Beta - expect rough edges. Found one? Click to report it."
    >
      Beta
    </a>
  );
}
